import React, { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import mclovin from '../Imatges/mclovin.jpg'
import logo from '../Imatges/logoUsuari.jpg'
import CachaunCompressed from '../Video/Cachaun-compressed2.mp4'
import './Compra.css'
import SearchBar from '../Components/searchBar'
import { useTheme } from '../ThemeContext'
import { AnimatedThemeToggler } from '../Components/themeToggler'
import { getVehiclesByType } from '../services/vehicleService'
import { searchVehicles } from '../services/searchService'
import VehicleCard from '../Components/VehicleCard'
import { useAuth } from '../contexts/AuthContext'
import Navigation from '../Components/Navigation'

function Compra() {
  const [showMenu, setShowMenu] = useState(false)
  const [searchResults, setSearchResults] = useState(null)
  const [vehicles, setVehicles] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const { isDarkMode, toggleTheme } = useTheme()
  const { user, signOut } = useAuth()
  const navigate = useNavigate()

  // Tancar menú en fer clic fora
  useEffect(() => {
    const handleClickOutside = event => {
      if (showMenu && !event.target.closest('.contenidorPerfil')) {
        setShowMenu(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [showMenu])

  // Carregar vehicles de compra quan es munta el component
  useEffect(() => {
    const loadPurchaseVehicles = async () => {
      try {
        setLoading(true)
        const purchaseVehicles = await getVehiclesByType('Comprar')
        setVehicles(purchaseVehicles)
      } catch (err) {
        setError('Error en carregar els vehicles de compra')
        console.error(err)
      } finally {
        setLoading(false)
      }
    }

    loadPurchaseVehicles()
  }, [])

  // Funció per gestionar la cerca (només en vehicles de compra)
  const handleSearch = async searchTerm => {
    try {
      setLoading(true)
      // Cercar només en vehicles de tipus "Comprar"
      const results = await searchVehicles(searchTerm, 'Comprar')
      setSearchResults(results)
      setLoading(false)
    } catch (err) {
      console.error('Error en cerca:', err)
      setError('Error en cercar vehicles')
      setLoading(false)
    }
  }

  // Funció per netejar la cerca
  const handleClearSearch = () => {
    setSearchResults(null)
  }

  // Determinar quins vehicles mostrar
  const vehiclesToDisplay = searchResults !== null ? searchResults : vehicles

  return (
    <div className='App'>
      <img src={mclovin} className='mclovin-logo' alt='imatge_mclovin' />
      {/* Icona del perfil a dalt a la dreta */}
      <div className='contenidorPerfil'>
        <div className='desplegablePerfil'>
          <img src={logo} className='logo-usuari' alt='usuari_logo' onClick={() => setShowMenu(!showMenu)} style={{ cursor: 'pointer' }} />
          {showMenu && (
            <div className='menuPerfil'>
              <p>Perfil</p>
              <p>Configuración</p>
              <p>Idioma</p>
              {user && (
                <p
                  onClick={() => {
                    navigate('/mis-vehiculos')
                    setShowMenu(false)
                  }}
                  style={{ cursor: 'pointer', color: '#61dafb', fontWeight: 'bold' }}
                >
                  Mis Vehículos
                </p>
              )}
              <p
                onClick={() => {
                  console.log('🔴 CLICK en Cerrar sesión')
                  setShowMenu(false)
                  signOut()
                  console.log('🔀 Redirigiendo a /login...')
                  window.location.href = '/login'
                }}
                style={{ cursor: 'pointer', color: '#61dafb', fontWeight: 'bold' }}
              >
                Cerrar sesión
              </p>
              <p>Ajuda</p>
              <div style={{ display: 'block', alignItems: 'center', gap: '10px', padding: '10px 0' }}>
                <AnimatedThemeToggler />
              </div>
            </div>
          )}
        </div>
      </div>
      <header className='appCabecera'>
        <h1 className='titulPrincipal' onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
          MotorVault
        </h1>
        {/* Barra de menús con componente Navigation */}
        <Navigation />
        <SearchBar onSearch={handleSearch} onClear={handleClearSearch} placeholder='Buscar vehículos en venta...' />
      </header>

      {/* Nueva sección para el video */}
      <div className='video-section'>
        <video className='video-player' autoPlay muted loop playsInline>
          <source src={CachaunCompressed} type='video/mp4' />
        </video>
      </div>
      {/* Sección de vehículos destacados */}
      <div className='vehicles-section'>
        <h2 className='section-title' style={{ color: '#61dafb' }}>
          {searchResults !== null ? `Resultados en Compra (${searchResults.length})` : 'Vehículos en Venta'}
        </h2>
        {loading ? (
          <p style={{ textAlign: 'center', color: 'var(--text-color)' }}>Cargando vehículos...</p>
        ) : error ? (
          <p style={{ textAlign: 'center', color: 'red' }}>{error}</p>
        ) : searchResults !== null && searchResults.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '40px', color: '#888' }}>
            <p style={{ fontSize: '20px' }}>😕 No se encontraron vehículos de compra</p>
            <p>Intenta con otros términos de búsqueda</p>
          </div>
        ) : vehiclesToDisplay.length === 0 ? (
          <p style={{ textAlign: 'center', color: 'var(--text-color)' }}>No hay vehículos disponibles para comprar</p>
        ) : (
          <>
            {/* Carousel Row 1 - Vehículos 0-4 */}
            {vehiclesToDisplay.slice(0, 5).length > 0 && (
              <div className='carousel-row'>
                <div className='carousel' mask='true'>
                  {vehiclesToDisplay.slice(0, 5).map(vehicle => (
                    <VehicleCard key={vehicle['vehicle_id(PK)']} vehicle={vehicle} />
                  ))}
                </div>
              </div>
            )}

            {/* Carousel Row 2 - Vehículos 5-9 */}
            {vehiclesToDisplay.slice(5, 10).length > 0 && (
              <div className='carousel-row'>
                <div className='carousel' mask='true' reverse='true'>
                  {vehiclesToDisplay.slice(5, 10).map(vehicle => (
                    <VehicleCard key={vehicle['vehicle_id(PK)']} vehicle={vehicle} />
                  ))}
                </div>
              </div>
            )}

            {/* Carousel Row 3 - Vehículos 10-14 */}
            {vehiclesToDisplay.slice(10, 15).length > 0 && (
              <div className='carousel-row'>
                <div className='carousel' mask='true'>
                  {vehiclesToDisplay.slice(10, 15).map(vehicle => (
                    <VehicleCard key={vehicle['vehicle_id(PK)']} vehicle={vehicle} />
                  ))}
                </div>
              </div>
            )}

            {/* Carousel Row 4 - Vehículos 15-19 (si hay más) */}
            {vehiclesToDisplay.slice(15, 20).length > 0 && (
              <div className='carousel-row'>
                <div className='carousel' mask='true' reverse='true'>
                  {vehiclesToDisplay.slice(15, 20).map(vehicle => (
                    <VehicleCard key={vehicle['vehicle_id(PK)']} vehicle={vehicle} />
                  ))}
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default Compra
